import Hero from './components/Hero';
import About from './components/About';
import TechBar from './components/TechBar';
import Differentials from './components/Differentials';
import Packages from './components/Packages';
import Tasting from './components/Tasting';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="bg-black">
      <Hero />
      <About />
      <TechBar />
      <Differentials />
      <Packages />
      <Tasting />
      <Footer />
    </main>
  );
}
